export default __webpack_public_path__ + "static/media/SG-Green-0003.2dfd477e.png";